<div class="filter">
  <div class="action">
    <div class="action-wrap">
      <select
        *ngIf="dropDownChoices"
        class="form-control w-auto"
        (change)="onSelect($event)"
      >
        <option value="ALL">ALL</option>
        <option
          *ngFor="let choices of dropDownChoices"
          [value]="choices?.value || choices"
        >
          {{ choices?.name || choices }}
        </option>
      </select>
      <form class="search">
        <div class="form-inline">
          <div class="form-group has-icon">
            <input
              type="search"
              class="form-control"
              [placeholder]="searchPlaceholder || 'Search'"
              [formControl]="search"
              autofocus
            />
            <i class="fas fa-search form-control-icon"></i>
          </div>
        </div>
      </form>
      <ng-content></ng-content>
    </div>
    <div class="btn-wrap">
      <ng-content select="[settings]"></ng-content>
    </div>
  </div>
</div>
